


































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import EmptyState from '@/app/ui/components/EmptyState/EmptyState.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import controller from '@/app/ui/controllers/PackageController'
import { Utils } from '@/app/infrastructures/misc'
import { Package } from '@/domain/entities/Package'
import Badge from '@/app/ui/components/Badge/index.vue'
import Skeleton from '@/app/ui/components/Skeleton/index.vue'

@Component({
  components: {
    EmptyState,
    LoadingOverlay,
    Badge,
    Skeleton
  },
})
class PackageDetailPage extends Vue {
  isAllData = false;
  controller = controller

  packageData = new Package()

  mounted(): void {
    this.getPackage();
    this.onSetDisplayBreadcrumb(false)
  }

  get isLoading(): boolean {
    return controller.isLoading
  }

  get packageDate(): string {
    return Utils.formatTimeZone(
      Utils.formatDateWithIDLocale(
        <string>controller.packageData.createdAt,
        'DD MMM YYYY HH:mm Z'
      )
    )
  }

  get productType(): string {
    return (this.packageData.productType || "").toLowerCase();
  }

  private onSetDisplayBreadcrumb(isDisplayed: boolean): void {
    const breadcrumb = document.getElementById('breadcrumb')
    if (breadcrumb) {
      if (isDisplayed) {
        breadcrumb.style.display = 'flex'
      } else {
        breadcrumb.style.display = 'none'
      }
    }
  }

  private historyDate(date: string): string {
    return Utils.formatTimeZone(
      Utils.formatDateWithIDLocale(<string>date, 'DD MMM YYYY HH : mm Z')
    )
  }

  private checkIsDEX(status: string): boolean {
    return status === 'DEX'
  }

  async getPackage() {
    await this.controller.getPackage({id: this.$route.params.packageId, isAllData: this.isAllData})
  }

  async onToggleAllData() {
    this.isAllData = !this.isAllData;
    await this.getPackage();
  }

  @Watch('controller.packageData')
  onPackageDataChange(data: Package): void {
    this.packageData = data
  }

  beforeDestroy(): void {
    this.onSetDisplayBreadcrumb(true)
    this.controller.setPackageData(new Package())
  }
}

export default PackageDetailPage;
